// Buy Direct page specific translations - English
export const buyDirectEn = {
  hero: {
    title: 'Sell Your Car',
    description:
      'Sell your vehicle quickly, safely, and at the best price. Fair appraisal and immediate payment.',
  },
  form: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    brand: 'Brand',
    brandPlaceholder: 'Select a brand',
    model: 'Model',
    modelPlaceholder: 'Select a model',
    year: 'Year',
    mileage: 'Mileage',
    condition: 'Vehicle Condition',
    askingPrice: 'Asking price',
    message: 'Additional details',
    plate: 'License plate',
    platePlaceholder: 'E.g. ABCD12',
    plateInvalid: 'Check the license plate: letters and numbers, like ABCD12.',
    version: 'Trim (optional)',
    versionPlaceholder: 'E.g. EXL 1.5 CVT',
    submit: 'Request Appraisal',
  },
  info: {
    advantagesTitle: 'Why Sell Your Car to Us',
    benefitsTitle: 'Our advantages',
    benefitsList: {
      item1: 'Fair appraisal based on real market value',
      item2: 'Guaranteed immediate payment',
      item3: 'We handle all the paperwork',
      item4: 'No hidden fees or commissions',
      item5: 'Fast and secure process',
    },
    processTitle: 'Sales process',
    processList: {
      step1: 'Submit basic vehicle information',
      step2: 'Technical evaluation and appraisal',
      step3: 'Formal purchase offer',
      step4: 'Document signing and transfer',
      step5: 'Immediate payment',
    },
    directContactTitle: 'Direct Contact',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
  },
  embed: {
    infoTitle: 'How does it work?',
    steps: [
      { title: 'Send your info', desc: 'Fill out the form with your vehicle details.' },
      { title: 'We evaluate', desc: 'Our team reviews and evaluates your vehicle.' },
      { title: 'We make you an offer', desc: 'You will receive a fair and transparent offer.' },
      { title: 'Immediate payment', desc: 'If you accept, we process payment immediately.' },
    ],
    benefitsTitle: 'Benefits',
    benefits: ['Instant offer', 'Immediate payment', 'No hidden fees', 'Paperwork included'],
  },
};

